import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DefaultRequiredPositions, SigningKey } from '@models/profile';

@Component({
  selector: 'app-signing-key',
  templateUrl: './signing-key.component.html',
  styleUrls: ['./signing-key.component.scss']
})
export class SigningKeyComponent implements OnInit, OnChanges {
  allPositions = DefaultRequiredPositions;
  @Input() requiredPositions = this.allPositions;
  @Input() resetValue = false;
  @Output() key = new EventEmitter();

  showKey = false;

  inputTyped: SigningKey[] = [];
  keyInputForm: FormGroup;

  constructor() {}

  get allPositionsIndexes() {
    return this.allPositions.map(pos => pos.position);
  }

  get requiredPositionIndexes() {
    return this.requiredPositions.map(pos => pos.position);
  }

  ngOnInit() {
     this.setPositionsFormGroup();
  }

  ngOnChanges({ requiredPositions, resetValue }: SimpleChanges) {
    if (requiredPositions) {
      this.requiredPositions = requiredPositions.currentValue;
      this.setPositionsFormGroup();
    }
    if (resetValue && this.keyInputForm) {
      this.keyInputForm.reset();
    }
  }

  onInput(itemPosition: number) {
    const currentValue = this.keyInputForm.get(itemPosition.toString()).value;
    this.pushToArray(this.inputTyped, {
      position: itemPosition,
      value: currentValue
    });

    this.key.emit(this.inputTyped);
  }

  private setPositionsFormGroup() {
    const group = {};
    this.allPositionsIndexes.forEach(position => {
      group[position] = new FormControl(
        {
          value: null,
          disabled: !this.requiredPositionIndexes.includes(position)
        },
        [Validators.required]
      );
    });
    this.keyInputForm = new FormGroup(group);
  }

  getParsedPositionsExceptLast() {
    let res = '';
    const arrayedPositions = this.requiredPositions.map(pos => pos.position);

    // Don't want to see a ', ' before 'y' or 'and' word (see .json)
    arrayedPositions
      .slice(0, arrayedPositions.length - 2)
      .forEach(pos => (res += pos + ', '));

    res += arrayedPositions[arrayedPositions.length - 2];
    return res;
  }

  private pushToArray(keys: SigningKey[], value: SigningKey) {
    const index = keys.findIndex(e => e.position === value.position);
    if (index === -1) {
      keys.push(value);
    } else {
      keys[index] = value;
    }
    keys.sort((a, b) => a.position - b.position);
  }
}
